import { Injectable } from '@angular/core';
import { each } from 'lodash';

import { Card } from '../../../../interfaces/card';
import { CardColumnBase } from '../card-column-base';

@Injectable()
export abstract class CardColumnDisplayBase extends CardColumnBase {
  constructor() {
    super();
  }

  // Collection of Card objects to pass to the card column component. The Card column component displays these
  // cards.
  cardCollection: Card[] = [];

  // Activated when a user types text into the filter bar at the top of the modal.
  override filter(text: string) {
    // Utilize case insensitivity when performing filtering.
    const formattedFilterText = text.toLowerCase();
    each(this.cardCollection, (card: Card) => {
      if (
        card.bodyText &&
        !card.bodyText.toLowerCase().includes(formattedFilterText)
      ) {
        card.isHidden = true;
      } else if (
        card.title &&
        !card.title.toLowerCase().includes(formattedFilterText)
      ) {
        card.isHidden = true;
      } else {
        card.isHidden = false;
      }
    });
  }

  override clearFilter() {
    each(this.cardCollection, (card: Card) => {
      card.isHidden = false;
    });
  }
}
